document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("backToTop");

  if (!btn) return;

  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    const scrollPercent =
      docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    btn.style.background = `
      conic-gradient(
        rgb(124, 82, 75) ${scrollPercent}%,
        rgb(218 171 163 / 60%) ${scrollPercent}%
      )
    `;

    if (scrollTop > 200) {
      btn.classList.add("show");
    } else {
      btn.classList.remove("show");
    }
  });

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});